module.exports = __webpack_public_path__ + "fonts/materialiconsoutlined.57b96f9c.woff2";